import React from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';
import {
  FiArrowLeft,
  FiChevronRight,
  FiColumns,
  FiUsers,
  FiSettings,
  FiPlus,
} from 'react-icons/fi';
import { routesPath } from '../../constants/routesPath';
import { isBinned } from './projectCandidateView';
import styles from './projectWorkspace.module.scss';

export const ProjectWorkspaceHeader = ({ project }) => {
  const { projectId, pipelineId } = useParams();
  const count = (project?.projects_pipeline_stages_users || []).filter(
    (row) => !isBinned(row),
  ).length;
  return (
    <header className={styles.projectHeader}>
      <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
        <Link to={routesPath.dashboard}>
          <FiArrowLeft /> Projects
        </Link>
        <FiChevronRight />
        {project?.client?.title && (
          <>
            <span>{project.client.title}</span>
            <FiChevronRight />
          </>
        )}
        <span aria-current="page">{project?.title || 'Loading project…'}</span>
      </nav>
      <div className={styles.projectHeading}>
        <div className={styles.projectIdentity}>
          <span className={styles.projectMark} aria-hidden="true">
            <FiColumns />
          </span>
          <div>
            <span className={styles.eyebrow}>RECRUITING WORKSPACE</span>
            <h1>{project?.title || 'Your project'}</h1>
            <p>{project?.client?.title || 'Your candidates, from first conversation to offer.'}</p>
          </div>
        </div>
        <div className={styles.headerActions}>
          {project?.client_id && (
            <Link
              className={styles.secondaryButton}
              to={routesPath.updateProject(project.client_id, project.id)}
            >
              <FiSettings /> Project settings
            </Link>
          )}
          <Link className={styles.primaryButton} to={routesPath.searchCandidates()}>
            <FiPlus /> Find candidates
          </Link>
        </div>
      </div>
      <nav className={styles.viewTabs} aria-label="Project views">
        <NavLink
          to={routesPath.projectPipeline(
            project?.id || projectId,
            project?.pipeline_id || pipelineId || 'null',
          )}
          className={({ isActive }) => (isActive ? styles.activeTab : undefined)}
        >
          <FiColumns /> Pipeline <span>Board</span>
        </NavLink>
        <NavLink
          to={routesPath.projectCandidates(project?.id || projectId)}
          className={({ isActive }) => (isActive ? styles.activeTab : undefined)}
        >
          <FiUsers /> Candidates <span>{count}</span>
        </NavLink>
      </nav>
    </header>
  );
};
